import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  max-width: 100%;

  ${({ $styles }) => $styles}
`;

const Label = styled.span`
  position: absolute;
  pointer-events: none;
  min-width: 100%;
  ${({ $autoWidth }) =>
    $autoWidth &&
    css`
      width: max-content;
      max-width: 350%;
    `}
  transform: translateX(-50%);
  padding: 8px 10px;
  font-size: ${rem('12px')};
  color: var(--colors-lynch);
  line-height: 1.3em;
  border: 1px solid var(--colors-geyser);
  border-radius: 5px;
  background-color: var(--colors-blank);
  box-shadow: 0px 1px 5px ${({ theme }) => theme.colors.lynch_15};
  opacity: 0;
  text-align: center;
  transition: 0.3s ease;
  transition-property: opacity;

  left: 50%;
  ${({ $position }) => {
    switch ($position) {
      case 'top': {
        return css`
          bottom: calc(100% + 10px);
        `;
      }
      case 'bottom': {
        return css`
          top: calc(100% + 10px);
        `;
      }
      default:
        return null;
    }
  }}

  ${Wrapper}:hover &,
  ${Wrapper}:focus & {
    opacity: 1;
  }

  ${({ $styles }) => $styles}
`;

const Tooltip = ({ label, children, position, autoWidth, styles, ...props }) => (
  <Wrapper {...props} $styles={styles.wrapper}>
    {children}
    {label && (
      <Label $position={position} $autoWidth={autoWidth} $styles={styles.label}>
        {label}
      </Label>
    )}
  </Wrapper>
);

Tooltip.defaultProps = {
  position: 'top',
  styles: {},
};

Tooltip.propTypes = {
  /** Tooltip content */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]).isRequired,
  /** Text that shows inside the tooltip */
  label: PropTypes.string.isRequired,
  /** The label width grows beyond content */
  autoWidth: PropTypes.bool,
  /** Tooltip position relative to container  */
  position: PropTypes.oneOf(['top', 'bottom']),
  /** Custom CSS-in-JS styles override */
  styles: PropTypes.shape({
    wrapper: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default Tooltip;
